module.exports = __webpack_public_path__ + "static/media/up.6a313e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/up.png
// module id = 2118
// module chunks = 0